interface PrintIconProps {
  className?: string;
}

const PrintIcon: React.FC<PrintIconProps> = (props) => {
  return (
    <>
      <svg
        width="24"
        height="24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.className}
      >
        <path className="stroke-current" strokeWidth="2" d="M7 4h10v3H7z" />
        <path className="stroke-current" d="M5.5 9.5h4v1h-4zm1 4h12v1h-12z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 8h16v8h-3v2h3a2 2 0 0 0 2-2V6H2v10a2 2 0 0 0 2 2h4v-2H4V8Z"
          className="fill-current"
        />
        <path className="stroke-current" d="M9 14h7v4.586L13.586 21H9v-7Z" strokeWidth="2" />
      </svg>
    </>
  );
};

export default PrintIcon;
